import type { IntlShape } from "react-intl";

export type DangerousGoodsOption = {
  label: string;
  value: string;
  supportingText?: string;
};

export function getDangerousGoodsOptionsV2(intl: IntlShape): DangerousGoodsOption[] {
  const options: DangerousGoodsOption[] = [
    {
      value: "1",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class1",
        defaultMessage: "Class 1",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class1Description",
        defaultMessage: "Explosive substances and articles",
      }),
    },
    {
      value: "2",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class2",
        defaultMessage: "Class 2",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class2Description",
        defaultMessage: "Gassess",
      }),
    },
    {
      value: "3",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class3",
        defaultMessage: "Class 3",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class3Description",
        defaultMessage: "Flammable liquids",
      }),
    },
    {
      value: "4",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class4",
        defaultMessage: "Class 4",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class4Description",
        defaultMessage: "Flammable solids",
      }),
    },
    {
      value: "5",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class5",
        defaultMessage: "Class 5",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class5Description",
        defaultMessage: "Oxidising substances",
      }),
    },
    {
      value: "6",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class6",
        defaultMessage: "Class 6",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class6Description",
        defaultMessage: "Toxic and infectious substances",
      }),
    },
    {
      value: "7",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class7",
        defaultMessage: "Class 7",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class7Description",
        defaultMessage: "Radioactive material",
      }),
    },
    {
      value: "8",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class8",
        defaultMessage: "Class 8",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class8Description",
        defaultMessage: "Corrosives",
      }),
    },
    {
      value: "9",
      label: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class9",
        defaultMessage: "Class 9",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.dangerousGoods.class9Description",
        defaultMessage: "Miscellaneous",
      }),
    },
  ];

  return options.map((opt) => ({
    label: opt.label,
    value: String(opt.value),
    supportingText: opt.supportingText,
  }));
}
